<ion-header no-border>
    <div *ngIf="appHeader || kioskHeader" class="contentHeader">

      <ng-container *ngIf="appHeader">
        <div style="display: flex;">
          <ion-icon (click)="goBack()" class="homeIcon" name="arrow-back-outline"></ion-icon>
          <img *ngIf="tools.showLogo && logo" [src]="logo" class="logoHeader" />
        </div>
        
        <div style="display: flex; align-items: center; ">
          <!-- DEFAULT BUTTONS -->    
          <ng-container *ngIf="page && page == 'homeCity'">
            <button *ngIf="!myCustomRouteShowHeader()" (click)="clickButton($event,'IA')" id="sendRoute" class="headerButtons headerSendButton" style="padding: 13px 30px;"> 
              <span  class="headerSendButtonText">{{'Crea tu ruta con IA' | translate}}</span>
            </button>
            <button *ngIf="myCustomRouteShowHeader()" (click)="clickButton($event,'myRoute')" id="sendRoute" class="headerButtons headerSendButton" style="padding: 13px 30px;"> 
              <span  class="headerSendButtonText" >{{'Mi Ruta' | translate}}</span>
            </button>
          </ng-container>
          <!-- ROUTE BUTTONS -->
          <div *ngIf="CurrentUrl == '/custom-route'" style="display: flex; min-width: 80%; align-items: center; height: 90%; justify-content: flex-end;">
            <div class="ubicationButtons" style="display: flex">
              <button (click)="clickButton($event, 'start')" id="startPoint" class="headerButtons">
                <!-- <span class="headerTextButtons headerTextButtonStart"><span style="position: relative; top: 1px;">I</span></span> -->
                <span class="startPointCSS" style="font-weight: bold; width: 100%;" >{{'Punto Inicio' | translate}}</span>
              </button>
              <button (click)="clickButton($event, 'end')" id="endPoint" class="headerButtons" >
                <!-- <span class="headerTextButtons headerTextButtonEnd"><span style="position: relative; top: 1px;">F</span></span> -->
              <span class="endPointCSS" style="font-weight: bold; width: 100%;" >{{'Punto Final' | translate}}</span>
              </button>
            </div>
            <button (click)="clickButton($event, 'send')" id="sendRoute" class="headerButtons headerSendButton"> 
              <!-- <svg *ngIf="!showClientRouteInfo()" class="headerSendButtonImg" width="33" height="34" viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M31.875 12.4247H17.9961V3.57271L20.3336 5.75747C20.5395 5.95005 20.7984 6.04302 21.0574 6.04302C21.343 6.04302 21.6285 5.93013 21.8344 5.70435C22.2328 5.27271 22.2129 4.602 21.7812 4.20356L17.6574 0.352002C17.2523 -0.0265137 16.6148 -0.0265137 16.2098 0.352002L12.0859 4.20356C11.6543 4.602 11.6344 5.27935 12.0328 5.70435C12.4312 6.13599 13.1086 6.15591 13.5336 5.75747L15.8711 3.57935V12.4313H1.99219C1.40781 12.4313 0.929688 12.9094 0.929688 13.4938V32.7383C0.929688 33.3227 1.40781 33.8008 1.99219 33.8008H31.875C32.4594 33.8008 32.9375 33.3227 32.9375 32.7383V13.4872C32.9375 12.9028 32.4594 12.4247 31.875 12.4247ZM16.9336 20.7653C17.518 20.7653 17.9961 20.2872 17.9961 19.7028V14.5497H28.548L16.9336 22.8172L5.31914 14.5497H15.8711V19.7028C15.8711 20.2872 16.3492 20.7653 16.9336 20.7653ZM3.05469 31.6758V15.5524L16.316 24.9887C16.502 25.1215 16.7145 25.1879 16.9336 25.1879C17.1527 25.1879 17.3652 25.1215 17.5512 24.9887L30.8125 15.5524V31.6758H3.05469Z" />
              </svg> -->
              <span *ngIf="!showClientRouteInfo()" class="headerSendButtonText" >{{'Enviar' | translate}}</span>
              <span *ngIf="showClientRouteInfo()" class="headerSendButtonText" style="height: 34px;line-height: 26px;" >{{'Info' | translate}}</span>
            </button>  
          </div>

          <!-- LANGUAGES -->
          <div *ngIf="rest.langSelector?.length > 1" class="langsContainer">
            <ion-fab>
              <ion-fab-button edge class="langHeaderButton">
                <ng-container *ngIf="rest.device?.styleLanguage !== 'iso'; else isoCodeLangs">
                  <img [src]="'/assets/langs/' + translate.currentLang + '.svg'" style="width:100%; height:100%; position: relative; object-fit: cover;" />
                </ng-container>
                <ng-template #isoCodeLangs>
                  <span class="iso-code-lang">
                    {{ translate.currentLang }}
                  </span>
                </ng-template>
              </ion-fab-button>
              <ion-fab-list [class]="reverseFab ? 'ion-fab-list-reverse' : 'ion-fab-list'" [side]="reverseFab ? 'top' : 'bottom'">
                <ng-container *ngFor="let langs of rest.langSelector">
                  <ion-fab-button *ngIf="langs.code != translate.currentLang" size="large" class="ion-fab-list-button" (click)="changeLanguage(langs.code)">
                    <div
                      [ngStyle]="rest.device?.styleLanguage === 'iso' ? { 'width': '100%' } : {}"
                      style="height:100%"
                    >
                      <ng-container *ngIf="rest.device?.styleLanguage !== 'iso'; else isoCodeLangs">
                        <img style="position: relative; left: 0px; height: 100%; max-width: none !important;" [src]="langs.img" />
                      </ng-container>
                      <ng-template #isoCodeLangs>
                        <span class="iso-code-lang">
                          {{ langs.code }}
                        </span>
                      </ng-template>
                    </div>
                  </ion-fab-button>
                </ng-container>
              </ion-fab-list>
            </ion-fab>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="kioskHeader">
        <div style="display: flex;  width: 100%; justify-content: center;">
          <img *ngIf="tools.showLogo && logo" [src]="logo" class="logoHeader" />
        </div>
      </ng-container>

    </div>
</ion-header>

